<template>
<div id="container_app">
   <div class="locationWrap support">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>이용안내
       </strong>
     </div>
   </div>
   <div class="contents">
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo">
         <h2>고객 문의</h2>
       </div>
       <div class = "tab_wrap">
       <ValidationObserver v-slot="{ invalid }" ref="qnaObserver">
        <div class="tab" v-show="showvalue">
          <span @click="test1Click" :class="{ active: test1 || test2 }"><a>제품 관련 문의</a></span>
          <span @click="test3Click" :class="{ active: test3 }"><a>플랫폼 관련 문의</a></span>
       </div>
       <div class="inputArea" v-if="test1">
        
        <div clsass = "model_list_wrap">
  
          <ul class="model_list">
            <li>
              <div class = "test11">
                <div class = "test22">
                  <a class = "a111">PORE</a>
                </div>
                <img src="/static/images/common/PORE.png" class ="model_src">
                <ul class="sub_model">
                  <div class = lidiv_test>
                    <li><a href="javascript:" @click="modelCheck($event)">ECP-800</a></li>
                    <li><a href="javascript:" @click="modelCheck($event)">ECP-900</a></li>
                    <li><a href="javascript:" @click="modelCheck($event)">FG_AWM240</a></li>
                  </div>
                </ul>
              </div>
            </li>
            <li>
              <div class = "test11">
                <div class = "test22">
                  <a class = "a111">PURIUM</a>
                </div>
                <img src="/static/images/common/purium.png" class ="model_src">
                <ul class="sub_model">
                  <div class = lidiv_test>
                    <li><a href="javascript:" @click="modelCheck($event)">test1</a></li>
                    <li><a href="javascript:" @click="modelCheck($event)">test2</a></li>
                  </div>
                </ul>
             </div>
            </li>
            <li>
              <div class = "test11">
                <div class = "test22">
                  <a class = "a111">DAMDA</a>
                </div>
                <img src="/static/images/common/PORE.png" class ="model_src">
                <ul class="sub_model">
                  <div class = lidiv_test>
                    <li><a href="javascript:" @click="modelCheck($event)">test1</a></li>
                  </div>
                </ul>
              </div>
            </li>
          </ul>

        </div>
      </div>
      
      <div class="inputArea" v-if="test2">
        <dl>
         <dt>모델명</dt>
         <dd class="input_Box">
          <div>
            <!-- <input type = "text" id = "modelcheck" name="modelcheck" class = "modelcheck" readonly> -->
            <input type="text" name="title" class="input_ty2" v-model="modelC" readonly>
          </div>
         </dd>
       </dl>

       <dl>
         <dt>제목 <span>(필수)</span></dt>
         <dd class="input_Box">
          <ValidationProvider name="title" rules="required" v-slot="{ errors }">
           <input type="text" name="title" class="input_ty2" placeholder="제목을 30자 내외로 작성해 주세요." v-model="item.title" autocomplete="off">
           <span class="is-invalid">{{ errors[0] }}</span>
          </ValidationProvider>
         </dd>
       </dl>

       <dl>
         <dt>답변 받으실 방식</dt>

          <input type="radio" class="em" name="eamilsms" id="eamilsms_1" v-model="emailtest" value="remail" autocomplete="off" checked>
          <label class="" for="eamilsms_1">E-Mail</label>

          <input type="radio" class="em" name="eamilsms" id="eamilsms_2" v-model="emailtest" value="rsms" autocomplete="off">
          <label class="" for="eamilsms_2">SMS</label>

         <dd class="inputBox type_email" v-show = "emailtest === 'remail'">
           <p><input type="text" name="email_1" class="input_ty3" placeholder="" v-model="email1"><span>@</span><input type="text" id="email_2" name="email_2" class="input_ty4" value="" v-model="email2" :readonly="isPoss"></p>
           <select name="service_name" id="service_name" class="select_ty3" @change="onChange($event)" v-model="mailOpt">
             <option value="D">직접입력</option>
             <option value="naver.com">naver.com</option>
             <option value="hanmail.net">hanmail.net</option>
             <option value="nate.com">nate.com</option>
             <option value="gmail.com">gmail.com</option>
           </select>
         </dd>

         <dd class="inputBox type_sms" v-show = "emailtest === 'rsms'">
           <p><input type="text" name="sms_1" class="input_ty3" placeholder="" v-model="sms1"></p>
         </dd>

       </dl>
       <dl>
         <dt>제품 정보</dt>
         <dd class="inputBox2">
           <span>성함</span><input type="text" name="model" class="border_test" placeholder="model." v-model="item.model" autocomplete="off">
           <span>휴대전화번호</span><input type="text" name="mobile" class="border_test" placeholder="mobile." v-model="item.mobile" autocomplete="off">
           <span>제품번호</span><input type="text" name="modelid" class="border_test" placeholder="modelid." v-model="item.modelid" autocomplete="off">
           <span>앱 ID</span><input type="text" name="userid" class="border_test" placeholder="userid." v-model="item.userid" autocomplete="off">
         </dd>
       </dl>
       <dl>
         <dt>문의 유형</dt>
         <dd class="inputBox">

          <input type="radio" class="btn-check" name="options" id="option1" autocomplete="off" checked>
          <label class="btn btn-secondary" for="option1">제품정보</label>
          
          <input type="radio" class="btn-check" name="options" id="option2" autocomplete="off">
          <label class="btn btn-secondary" for="option2">제품사용법</label>
          
          <input type="radio" class="btn-check" name="options" id="option3" autocomplete="off">
          <label class="btn btn-secondary" for="option3">A/S</label>

          <input type="radio" class="btn-check" name="options" id="option4" autocomplete="off">
          <label class="btn btn-secondary" for="option4">제품등록</label>

         </dd>
       </dl>
       <dl>
         <dt>내용 <span>(필수)</span></dt>
         <dd class="input_Box">
          <ValidationProvider name="contents" rules="required" v-slot="{ errors }">
           <textarea class="ta_ty1" name="contents" v-model="item.contents" placeholder="불건전한 내용 및 광고성 게시물은 사전 통보없이 삭제 처리될 수 있습니다."></textarea>
           <span class="is-invalid">{{ errors[0] }}</span>
          </ValidationProvider>
         </dd>
       </dl>

       <div class="infoBox bg_gray aniBox type_bot gogo">
        <p>- 문의하신 내용에 대한 답변이 작성되면 이메일로 알림이 발송되며, 본 홈페이지 '마이페이지' 에서 답변 확인이 가능합니다.</p>
        <!--p>- 첨부파일은 DOC, DOCX, PPT, PPTX, XLS, XLSX, PDF, HWP, JPG, GIF, PNG만 업로드 가능합니다.</p-->
      </div>

       <div class="btn_area taC aniBox type_top gogo">
         <a href="javascript:" class="btn_blue" @click="saveQna()">문의등록</a> <router-link to="/" class="btn_ty1">취소</router-link>
       </div>

      </div>


       <div class="inputArea" v-if="test3">
        <dl>
          <dt>제목 <span>(필수)</span></dt>
          <dd class="input_Box">
           <ValidationProvider name="title" rules="required" v-slot="{ errors }">
            <input type="text" name="title" class="input_ty2" placeholder="제목을 30자 내외로 작성해 주세요." v-model="item.title" autocomplete="off">
            <span class="is-invalid">{{ errors[0] }}</span>
           </ValidationProvider>
          </dd>
        </dl>
        <dl>
         <dt>답변 받으실 방식</dt>

          <input type="radio" class="em" name="eamilsms" id="eamilsms_1" v-model="emailtest" value="remail" autocomplete="off" checked>
          <label class="" for="eamilsms_1">E-Mail</label>

          <input type="radio" class="em" name="eamilsms" id="eamilsms_2" v-model="emailtest" value="rsms" autocomplete="off">
          <label class="" for="eamilsms_2">SMS</label>

         <dd class="inputBox type_email" v-show = "emailtest === 'remail'">
           <p><input type="text" name="email_1" class="input_ty3" placeholder="" v-model="email1"><span>@</span><input type="text" id="email_2" name="email_2" class="input_ty4" value="" v-model="email2" :readonly="isPoss"></p>
           <select name="service_name" id="service_name" class="select_ty3" @change="onChange($event)" v-model="mailOpt">
             <option value="D">직접입력</option>
             <option value="naver.com">naver.com</option>
             <option value="hanmail.net">hanmail.net</option>
             <option value="nate.com">nate.com</option>
             <option value="gmail.com">gmail.com</option>
           </select>
         </dd>

         <dd class="inputBox type_sms" v-show = "emailtest === 'rsms'">
           <p><input type="text" name="sms_1" class="input_ty3" placeholder="" v-model="sms1"></p>
         </dd>

       </dl>

       <dl>
         <dt>문의 유형</dt>
         <dd class="inputBox">

          <input type="radio" class="btn-check" name="options" id="option1" autocomplete="off" checked>
          <label class="btn btn-secondary" for="option1">플랫폼 이용</label>
          
          <input type="radio" class="btn-check" name="options" id="option2" autocomplete="off">
          <label class="btn btn-secondary" for="option2">기업협의회 가입</label>
          
          <input type="radio" class="btn-check" name="options" id="option3" autocomplete="off">
          <label class="btn btn-secondary" for="option3">제품 연동</label>

          <input type="radio" class="btn-check" name="options" id="option4" autocomplete="off">
          <label class="btn btn-secondary" for="option4">가이드 문서</label>

          <input type="radio" class="btn-check" name="options" id="option5" autocomplete="off">
          <label class="btn btn-secondary" for="option5">기타</label>

         </dd>
       </dl>

       <dl>
          <dt>내용 <span>(필수)</span></dt>
          <dd class="input_Box">
           <ValidationProvider name="contents" rules="required" v-slot="{ errors }">
            <textarea class="ta_ty1" name="contents" v-model="item.contents" placeholder="불건전한 내용 및 광고성 게시물은 사전 통보없이 삭제 처리될 수 있습니다."></textarea>
            <span class="is-invalid">{{ errors[0] }}</span>
           </ValidationProvider>
          </dd>
        </dl>

        <div class="infoBox bg_gray aniBox type_bot gogo">
        <p>- 문의하신 내용에 대한 답변이 작성되면 등록하신 이메일 혹은 SMS로 답변이 발송되며, 본 홈페이지 '문의처리현황' 에서 답변 확인이 가능합니다.</p>
        <!--p>- 첨부파일은 DOC, DOCX, PPT, PPTX, XLS, XLSX, PDF, HWP, JPG, GIF, PNG만 업로드 가능합니다.</p-->
      </div>

       <div class="btn_area taC aniBox type_top gogo">
         <a href="javascript:" class="btn_blue" @click="saveQna()">문의등록</a> <router-link to="/" class="btn_ty1">취소</router-link>
       </div>

       </div>

       <div class="inputArea" v-if="test4">
        <div class="mun_1">
          <div>문의가 접수되었습니다.</div>
          <span>접수 번호 : 123456789</span>
          <div>문의하신 내역은 문의처리현황에서 조회하실 수 있습니다.</div>
          <a href="javascript:" class="btn_blue" @click="goQnAlist()">문의처리현황</a>
        </div>
       </div>

      </ValidationObserver>
      
    </div>
<!-- 
      <div class="infoBox bg_gray aniBox type_bot gogo">
        <p>- 문의하신 내용에 대한 답변이 작성되면 이메일로 알림이 발송되며, 본 홈페이지 '마이페이지' 에서 답변 확인이 가능합니다.</p>
        <!-p>- 첨부파일은 DOC, DOCX, PPT, PPTX, XLS, XLSX, PDF, HWP, JPG, GIF, PNG만 업로드 가능합니다.</p->
      </div>

       <div class="btn_area taC aniBox type_top gogo">
         <a href="javascript:" class="btn_blue" @click="saveQna()">문의등록</a> <router-link to="/" class="btn_ty1">취소</router-link>
       </div> -->

     </div>

   </div>
   <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"></loading>
 </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { email, required } from 'vee-validate/dist/rules'
import ko from 'vee-validate/dist/locale/ko.json'
import FileUpload from 'vue-upload-component'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

localize(ko)
extend('required', {
  ...required,
  message: '필수 입력 항목입니다.'
})

export default {
  name: 'SupportQna',
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
    Loading
  },
  data () {
    return {
      test1: true,
      test2: false,
      test3: false,
      test4: false,
      item: {
        title: '',
        contents: '',
        rcvEmail: '',
        files: []
      },
      showvalue: true,
      modelC: '',
      emailtest: 'remail',
      email1: '',
      email2: '',
      sms1: '',
      isPoss: false,
      mailOpt: 'D',
      files: [],
      isLoading: false,
      fullPage: true
    }
  },
  methods: {
    test1Click() {
      this.test1 = true;
      if (this.test1) {
        this.test2 = false;
        this.test3 = false;
      }
    },
    test3Click() {
      this.test3 = true;
      if (this.test3) {
        this.test1 = false;
        this.test2 = false;
      }
    },
    modelCheck (event) {
      this.test2 = true;
      //var modelC = event.target.text
      //console.log('modelC : ', modelC)
      if (this.test2) {
        this.test1 = false;
        this.test3 = false;
      }
      
      this.modelC = event.target.text
    },
    goQnAlist () {
      this.$router.push('/support/faq')
    },
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    onChange (event) {
      var _this = this

      if (event.target.value === 'D') {
        _this.isPoss = false
        _this.email2 = ''
      } else {
        _this.isPoss = true
        _this.email2 = event.target
      }
    },
    saveQna () {
      var _this = this
      _this.$refs.qnaObserver.validate().then(valid => {
        if (valid) {
          _this.isLoading = true
          // if (emailtest === 'remail') { // 여기도 -> 체크박스 값 받아와서 이메일일때랑 SMS일때 구분해서 값 받아오는거 만들어야함
          //   _this.item.rcvEmail = _this.email1 + '@' + _this.email2
          //   console.log('if(email)들어옴')
          // } 
          // else if (emailtest === 'rsms') {
          //   _this.item.rcvEmail = _this.sms1
          //   console.log('if(sms)들어옴')
          // }
          if (_this.email1) { // 여기도 -> 체크박스 값 받아와서 이메일일때랑 SMS일때 구분해서 값 받아오는거 만들어야함
            _this.item.rcvEmail = _this.email1 + '@' + _this.email2
            console.log('if(email)들어옴데이터확인용$$$$$$', _this.item.rcvEmail)
          } 
          else if (_this.sms1) {
            _this.item.rcvEmail = _this.sms1
            console.log('if(sms)들어옴데이터확인용&&&&&&&&',_this.item.rcvEmail)
          } // 제대로 들어오는거 확인!!!!!
          axios({
            method: 'POST',
            url: '/web/api/board/QNA',
            data: this.item,
            withCredentials: true
          }).then((response) => {// 여기서 response.status 가 200이 안들어온다는건데
            if (response.status === 200) {
              _this.isLoading = false
              console.log('data : ', data)
              this.test2 = false
              this.test3 = false
              this.showvalue = false
              this.test4 = true
            } else {
              alert('저장에 실패하였습니다. 잠시 후 다시 이용 부탁드립니다.')
              _this.isLoading = false
            }
          }).catch((ex) => {
            alert('오류가 발생하였습니다. 관리자에게 문의하여 주십시오')
            _this.isLoading = false
            console.log('사용자 회원 가입 오류 : ', ex)

            //일단 이건 나중에 보자
            console.log('data : ', data)
            this.test2 = false
            this.test3 = false
            this.showvalue = false
            this.test4 = true
          })
        }
      })
    },
    inputFilter (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile (newFile, oldFile) {
      if (newFile && !oldFile) {
      }
      if (newFile && oldFile) {
      }
      if (!newFile && oldFile) {
      }
      // Get response data
      if (newFile.xhr) {
        //  Get the response status code
        if (newFile.xhr.status > 200) {
          alert('파일 업로드에 실패하였습니다. 잠시 후에 다시 시도해주세요')
        }
      }
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    updatetFileInfo (value) {
      if (value[0].response.result) {
        this.item.files = value[0].response.result
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.is-invalid { color:red;  line-height: 3; padding-left: 20px;}
</style>


// WEBPACK FOOTER //
// src/components/SupportQna.vue